import React from 'react'
import PropTypes from 'prop-types'
import Style from './style'
import { IMG } from '../../themes'

const defaultString = ''
const defaultFunction = () => {}

class DropDown2 extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showDropDown: false
    }
    this.dropDownRef = React.createRef()
  }

  toggleDropDown () {
    this.setState(prevState => ({ showDropDown: !prevState.showDropDown }), () => {
      if (this.state.showDropDown && this.dropDownRef.current) {
        this.dropDownRef.current.focus()
      }
    })
  }

  handleBlur () {
    // delay to allow click event to fire
    setTimeout(() => {
      if (this.state.showDropDown) {
        this.setState({ showDropDown: false })
      }
    }, 150)
  }

  handleMouseDown (event) {
    if (event.button === 0 && !this.props.disabled) {
      this.toggleDropDown()
      event.preventDefault()
    }
  }

  handleClick (event, item, index) {
    if (!this.props.disabled) {
      this.props.handleClick(event, item, index)
    }
    this.setState({ showDropDown: false })
    event.preventDefault()
  }

  handleClickEditable = () => {
    if (this.props.isShowExternalEditModal && this.props.handleEditModal) {
      this.props.handleEditModal()
      return
    }
    if (!this.props.disabled) {
      this.toggleDropDown();
      return;
    }
  };

  renderDropDown () {
    const props = Object.assign({}, this.props)
    return props.list.map((item, index) => <button key={item} onMouseDown={(event) => this.handleClick(event, item, index)}>{item}</button>)
  }

  render () {
    const { colorTheme } = this.props
    const props = Object.assign({}, this.props)
    return (
      <Style colorTheme={colorTheme}>
        <section className={'input-box '.concat(props.disabled ? ' disabled ' : defaultString).concat(props.className ? props.className : defaultString)}>
          <label onClick={this.handleClickEditable}>{props.currentValue || 0}</label>
          <section className='button-container' onMouseDown={(event) => this.handleMouseDown(event)}>
            <img 
              src={IMG['ic_expand-more.svg']} 
              alt='expand' 
              style={{ 
                width: '100%', 
                height: '100%',
                transition: 'transform 0.3s ease',
                transform: this.state.showDropDown ? 'rotate(180deg)' : 'rotate(0deg)'
              }} 
            />
          </section>
          <section className={`dropdown-container ${this.state.showDropDown ? 'is-showing' : ''}`} ref={this.dropDownRef} tabIndex={0} onBlur={!props.disabled ? () => this.handleBlur() : defaultFunction}>
            {this.renderDropDown()}
          </section>
        </section>
        <label className='label-text'>{props.label}</label>
      </Style>
    )
  }
}

DropDown2.propTypes = {
  handleClick: PropTypes.func.isRequired,
  currentValue: PropTypes.oneOfType([
    PropTypes.number.isRequired,
    PropTypes.string,
  ]),
  label: PropTypes.string
}

export default DropDown2
